import { CreateTicketForm } from '@/features/tickets/CreateTicketForm';

/**
 * /new-ticket — under ProtectedLayout. Thin wrapper so the route module is
 * pure (no logic) and the form component is reusable / testable independently.
 */
export function NewTicket() {
  return <CreateTicketForm />;
}
